import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import {
  filterGamesByTags,
  initGames,
  loadMoreGames,
  searchGames,
} from './games.actions';
import { GamesState } from './games.reducer';
import * as GamesSelectors from './games.selectors';
import { GameQueryParams } from '@fantaz/shared/data-access/models';

@Injectable()
export class GamesFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(GamesSelectors.getGamesLoaded));
  filtering$ = this.store.pipe(select(GamesSelectors.getGamesFilteringState));
  allResponse$ = this.store.pipe(select(GamesSelectors.getAllResponse));
  isAllGamesLoaded$ = this.store.pipe(select(GamesSelectors.isAllLoaded));
  paginationResponse$ = this.store.pipe(
    select(GamesSelectors.getPaginationResponse),
  );
  total$ = this.store.pipe(select(GamesSelectors.getGamesTotal));
  error$ = this.store.pipe(select(GamesSelectors.getGamesError));
  allGames$ = this.store.pipe(select(GamesSelectors.getAllGames));
  selectedTags$ = this.store.pipe(select(GamesSelectors.getGameSelectedTags));
  tags$ = this.store.pipe(select(GamesSelectors.getTags));

  constructor(private readonly store: Store<GamesState>) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init({ params }: { params: GameQueryParams }) {
    this.store.dispatch(initGames({ params }));
  }

  fetchMoreGames({ params }: { params: GameQueryParams }) {
    this.store.dispatch(loadMoreGames({ params }));
  }

  filterGamesByTags({ params }: { params: GameQueryParams }) {
    this.store.dispatch(filterGamesByTags({ params }));
  }

  searchGames({ params }: { params: GameQueryParams }) {
    this.store.dispatch(searchGames({ params }));
  }
}
